import { LocalizedPageTitle, OptimusProvider, PortfolioLayout, PortfolioLayoutHeader } from '@mews-commander/ui';
import { TextKey, ArticlePath, createGuideLink } from '@mews-commander/enums';
import { CancellationPolicyTable } from '../components/table';
import { CancellationPolicySidePanelContextProvider } from '../components/sidePanel';
import { CreateCancellationPolicyButton } from '../components/table/CreateCancellationPolicyButton';

export const CancellationPolicies = () => (
    <OptimusProvider density="spacious">
        <PortfolioLayout>
            <PortfolioLayoutHeader
                guideLink={createGuideLink(ArticlePath.HowToCreateMmpCancellationPolicy)}
                rightSide={<CreateCancellationPolicyButton />}
                title={<LocalizedPageTitle textKey={TextKey.CancellationPolicyPlural} />}
            />
            <CancellationPolicySidePanelContextProvider>
                <CancellationPolicyTable />
            </CancellationPolicySidePanelContextProvider>
        </PortfolioLayout>
    </OptimusProvider>
);
